import { render, staticRenderFns } from "./RecoveryPass.vue?vue&type=template&id=3d5f19e2&scoped=true&"
import script from "./RecoveryPass.vue?vue&type=script&lang=js&"
export * from "./RecoveryPass.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryPass.vue?vue&type=style&index=0&id=3d5f19e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f19e2",
  null
  
)

export default component.exports